import React from 'react';
import classNames from 'classnames';
import './index.less';

const DonutProgress = ({
  shouldAnimate,
  quantity,
  desc,
  title,
  className,
}: {
  shouldAnimate: boolean;
  quantity: string;
  title: string;
  desc: string[];
  className: string;
}) => {
  const radius = 15.91549430918954;
  return (
    <figure className={className}>
      <div className="figure-content">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 42 42"
          className="donut"
          aria-labelledby="donut-progress"
          role="img"
        >
          <circle
            className="donut-ring"
            cx="21"
            cy="21"
            r={radius}
            fill="transparent"
            stroke="#ff5533"
            strokeWidth="1"
            role="presentation"
          ></circle>

          <circle
            className={classNames('donut-segment', { animate: shouldAnimate })}
            cx="21"
            cy="21"
            r={radius}
            fill="transparent"
            stroke="#ffffff"
            strokeWidth="1"
            strokeDasharray="0 100"
            strokeDashoffset="25"
            aria-labelledby="donut-segment-1-title donut-segment-1-desc"
          ></circle>
          <g className={classNames('chart-text', { animate: shouldAnimate })}>
            <text x="50%" y="40%" className="chart-number">
              {quantity}
            </text>
            <text x="50%" y="46%" className="chart-title">
              {title}
            </text>
            {desc.map((d, i) => (
              <text key={`desc-${i}`} x="50%" y={`${52 + i * 4}%`} className="chart-desc">
                {d}
              </text>
            ))}
          </g>
        </svg>
      </div>
    </figure>
  );
};
export default DonutProgress;
